import { ascend, prop, sort } from 'ramda';
import { createAction } from 'redux-actions';

import { COMPANY } from 'constants/general';
import fetch from 'features/common/fetch';

import * as types from './actionTypes';
import { getOrganizationStructureAllowedRegions, getOrganizationStructureAllowedRegionsForSidebar } from './selectors';

const setRegions = createAction(types.FETCH_REGION_SUCCESS, (response) => ({ regions: response }));
const setEdkRegions = createAction(types.FETCH_EDK_REGION_SUCCESS, (response) => ({ regions: response.body.values }));

export const fetchIdkRegions =
	({ channelId, type, onSuccess, isGuarantor, campaignId, customAllowedRegions }) =>
	(dispatch, getState) => {
		return dispatch(
			fetch.actions.get(fetch.constants.urls.orgStructureRegions, {
				uniqueReqID: type ? type : null,
				queryParams: { channelId, companyId: COMPANY.CP },
				onSuccess: [
					(response) => () => {
						const byId = ascend(prop('id'));
						const sortedRegions = sort(byId, response.body);
						dispatch(setRegions(sortedRegions));

						const finalRegions =
							type === 'sidebar'
								? getOrganizationStructureAllowedRegionsForSidebar(
										getState(),
										isGuarantor,
										channelId,
										campaignId,
										customAllowedRegions,
								  )
								: getOrganizationStructureAllowedRegions(
										getState(),
										isGuarantor,
										channelId,
										campaignId,
								  );

						onSuccess(finalRegions);
					},
				],
			}),
		);
	};

export const fetchEdkRegions = (channelId, companyId, fetchSuffix) => (dispatch) => {
	const defeaultCompanyId = COMPANY.CP;
	const reqCompanyId = companyId || defeaultCompanyId;

	return dispatch(
		fetch.actions.get(
			fetch.constants.urls.orgStructureEdkRegions,
			Object.assign(
				{},
				fetchSuffix ? { uniqueReqID: fetchSuffix } : null,
				{ queryParams: { channelId, companyId: reqCompanyId } },
				{ onSuccess: [setEdkRegions] },
			),
		),
	);
};
